<template>
  <component :is="list.skipCardLayout?'div':'md-card'">
    <md-card-header class="md-card-header-icon md-card-header-green list-header" :class="list.hideListHeader? 'list-header-hidden' : ''">
      <template v-if="!list.hideListHeader">
        <!--div class="card-icon">
          <md-icon>{{ list.pageIcon }}</md-icon>
        </div-->
        <h4 class="title">{{ list.pageTitle }}</h4>
      </template>
      <!-- !list.addNewModal && -->
      <button v-if="list.openPopup" @click="atOpenPopup" class="md-button md-primary md-sm popupButton">New<md-icon class="md-small" style="margin-left: 5px">control_point</md-icon></button>
      <button v-if="!list.skipCardLayout && !list.hideNewRecordButton" v-on:click="newRecord()" class="md-button md-primary md-sm" style="float:right; margin-right:inherit">Add<md-icon class="md-small">control_point</md-icon></button>
      <button v-if="list.addNewModal" v-on:click="list.showAddNewModal = true" class="md-button md-primary md-sm" style="float:right; margin-right:inherit">Add<md-icon class="md-small">control_point</md-icon></button>
      <md-button id="messageListRefresh" class="md-just-icon md-simple" @click="refresh()"><md-icon>refresh</md-icon></md-button>
    </md-card-header>

    <component
      v-if="onlyShowListIf === null || onlyShowListIf"
      :is="list.skipCardLayout?'div':'md-card-content'">
      <div class="dynamicList-loading"
        v-show="isPromisePending">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>
      <md-snackbar :md-position="'center'" :md-duration="4000" :md-active.sync="searchError" md-persistent>
        <span>{{searchErrorMessage}}</span><!--<md-button class="md-primary" @click="showSnackbar = false">Retry</md-button>-->
      </md-snackbar>

      <div class="_addonFilters">
        <div class="_addonFilters__filter" v-for="_filter in addonFilters" :key="_filter.id">
          <md-autocomplete 
            class="_uiKitInput"
            v-model="_filter.value" 
            :md-options="_filter.options"
            @md-changed="onAddonFilterChange($event, _filter)"
            @md-selected="onAddonFilterSelect($event, _filter)"
          >
            <label>{{ _filter.placeholder }}</label>
            <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item[_filter.label] }}</template>
            <template slot="md-autocomplete-empty">No match found!</template>
          </md-autocomplete>
        </div>
      </div>

      <!-- ATLAS-1007: Link Case Option -->
      <div class="__modalDropdown" v-if="list.showModalDropdown">
        <md-field class="">
          <label for="pages">Select a reason why you are linking this case</label>
          <md-select v-model="selectedCaseLinkReason" :key="'linkReason'" name="caseLinkReason">
            <md-option
              v-for="item in list.caseLinkReasonOptions"
              :key="item"
              :label="item"
              :value="item"
            >
              {{ item }}
            </md-option>
          </md-select>
        </md-field>
      </div>

      <md-table
        :value="queriedData"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortDir"
        :md-sort-fn="customSort"
        :searchQuery="searchQuery"
        class="paginated-table table-striped table-hover"
      >
        <md-table-toolbar v-show="true !== list.isToolbarHidden">
          <md-field :class="{ '_uiKitInput _uiKitTableInput': false !== list.searchRecordsInput }">
            <label>Search</label>
            <md-input
              type="search"
              class="mb-3"
              clearable
              style="width: 200px"
              placeholder="Search records"
              v-model="searchQuery"
              ref="searchQuery"
              v-show="false !== list.searchRecordsInput"
            >
            </md-input>
          </md-field>

          <md-field 
            :class="{ '_uiKitInput _uiKitTableInput _uiKitTableSearch': true === list.isOfflineSearchEnabled }" 
            v-show="true !== list.isOfflineSearchHidden"
          >
            <label>Search</label>
            <md-input
              type="search"
              class="mb-3"
              clearable
              style="width: 200px"
              placeholder="Search records"
              v-model="offlineSearchQuery"
              ref="searchQuery"
              v-show="true === list.isOfflineSearchEnabled"
            >
            </md-input>
          </md-field>

          <md-field class="_uiKitInput">
            <label for="pages">Per page</label>
            <md-select v-model="currentPerPage" :key="'perPage' + activeDataName" name="pages" @change="search">
              <md-option
                v-for="item in list.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </md-table-toolbar>

        <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            @click.stop.native="list.linkRows? ( list.redirectNested? handleRedirectNested(item) : handleEdit(item) ) : false"
            :style="list.linkRows? 'cursor:pointer;' : ''"
            :class="ifOverdueTask(item) ? 'textRed' : ''"
        >

          <template v-for="(column, name) in list.columns">
            <template v-if="list.linkConfigs && list.linkConfigs.length && getLinkConfig(column, name)">
              <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">
                <a :href="callLinkHrefCallback(column, name, item)">
                  {{ callLinkTitleCallback(column, name, item) }}
                </a>
              </md-table-cell>
            </template>
            <template v-else>
              <md-table-cell
                :key="name"
                :md-label="column.label"
                :md-sort-by="column.sortable? name : null"
                :title="column.title ? item[column.title] : ''"
              >{{ `${getColumnDisplayValue(column, item, name)}` }}</md-table-cell>
            </template>
          </template>

          <md-table-cell md-label="Actions" v-if="!list.hideActionColumn">
            <template v-if="list.itemActions">
              <template v-for="(action) in list.itemActions">
                <md-button
                  :key="action.icon"
                  :class="item.added? action.classAdded : action.class"
                  @click.stop.native="callItemAction(action.click, item)"
                  v-show="!action.showCallback || action.showCallback(item)"
                >
                  <md-icon>{{item.added? action.iconAdded : action.icon}}</md-icon>
                </md-button>
              </template>
            </template>
            <template v-else>
              <md-button class="md-just-icon md-warning md-simple" @click.stop.native="handleEdit(item)">
                <md-icon>description</md-icon>
              </md-button>
              <md-button v-if="$Session.isAdminGroupMember" class="md-just-icon md-danger md-simple" @click.stop.native="handleDelete(item)">
                <md-icon>close</md-icon>
              </md-button>
            </template>
          </md-table-cell>
        </md-table-row>

      </md-table>
    </component>

    <md-card-actions md-alignment="space-between">
      <div class="">
        <p v-if="queriedData.length" class="card-category number">
          Showing {{ from + 1 }} to {{ from + queriedData.length }} of {{ activeData.items.length }} results fetched
        </p>
        <p v-else class="card-category">
          0 results
        </p>
      </div>
      <pagination
        v-show="queriedData.length"
        class="pagination-no-border pagination-success"
        v-model="activeData.curPage"
        :per-page="currentPerPage"
        :total="totalPages"
        :pageCount="totalPages"
        :nextToken="activeData.nextToken"
        @loadMore="loadMore"
      >
      </pagination>
    </md-card-actions>

    <!-- ATLAS-681 ElasticSearch error - no results - Alert Dialog -->
    <md-dialog-alert
      class="__alertDialog"
      :md-active.sync="mdAlertDialogShow"
      :md-title="mdAlertTitle"
      :md-content="mdAlertMessage" />

  </component>
</template>

<script>
  import RecordList from '@/mixins/RecordList';
  import moment from "moment";

  export default {
    mixins: [RecordList],
    props: {
      list: {
        type: Object,
        required: true
      },
      excludeColumns: {
        type: String,
        required: false
      },
      exclude: {
        type: Object,
        required: false
      },
      filter: {
        type: [Array, Object],
        required: false
      },
      atOpenPopup: {
        type: Function,
        required: false,
      },
    },
    watch: {
      '$route.params': function () {
        if(this.$route.query.q)
          this.$refs["searchQuery"].value = this.$route.query.q
      }
    },
    created() {
      if(this.$route.query.q)
        this.searchQuery = this.$route.query.q

      const exColumns = this.excludeColumns ? this.excludeColumns.split(",") : [];
      if (exColumns.length) {
        exColumns.forEach(excludedColumn => {
          if (this.list && this.list.columns && this.list.columns[excludedColumn]) {
            delete this.list.columns[excludedColumn];
          }
        })
      }
    },
    methods: {
      callItemAction(funcName, item) {
       if (typeof this[funcName] === 'function') {
          return this[funcName](item);
        }
        if ('function' === typeof funcName) {
          return funcName(item, this.queriedData);
        }
      },
      ifOverdueTask(item) {
        if(item.dateDue){
          if(moment(item.dateDue) <= moment().add(-1, 'days')){
            return true
          }else{
            return false
          }
        }else{
          return false
        }
      },
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions{
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .md-table-cell {
      overflow-wrap: break-word;
  }

  .md-card-header.list-header.list-header-hidden {
    padding-top: 12px;
  }

  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }

  ._addonFilters {
    display: flex;
    position: absolute;
    top: -2rem;
    left: 1.5rem;
  }
  
  ._addonFilters__filter {
    width: 200px;
    margin-left: -4px;
  }
  
  ._addonFilters__filter + ._addonFilters__filter {
    margin-left: 2rem;
  }

  .md-dialog.__alertDialog.md-theme-default {
    width: 45% !important;
  }

  /* For caseLinkReason modalDropdown */
  .__modalDropdown {
    max-width: 45%;
  }

  .popupButton {
    float: right;
    margin-right: inherit;
    top: 5px;
    position: absolute;
    height: 35px;
    right: 45px;  
    font-weight: 500;
  }

  .textRed{
    color: red;
  }
</style>
